import {TextBold16} from "@/app/components/texts";
import React, {memo} from "react";
import LazyImage from "@/app/components/lazy_image";
import styles from "./styles.module.scss";

interface Props {
  userAvatar?: string
  userName: string
  userAvatarInBase64?: string
}

const UserAvatar: React.FC<Props> = ({userAvatar, userName, userAvatarInBase64}) => {
  return (
    <div className={styles.image}>
      {!!userAvatarInBase64 ? (<img src={userAvatarInBase64} alt={userName} className={styles.avatar}/>) :
        userAvatar !== undefined && userAvatar !== null && userAvatar !== "" ? <LazyImage url={userAvatar} alt={userName}/> :
          <TextBold16 text={userName.charAt(0)}/>}
    </div>
  );
};

export default memo(UserAvatar);